import { create } from 'zustand';

import { IFilterOptions } from '../helpers/DataFilterHelper';

interface IDashboardFiltersStore {
	filters: IFilterOptions;
	setFilters: (filters: IFilterOptions) => void;
	updateFilter: (key: string, value: string | string[] | number) => void;
	clearFilters: () => void;
	hasActiveFilters: () => boolean;
}

export const useDashboardFiltersStore = create<IDashboardFiltersStore>((set, get) => ({
	filters: {},

	setFilters: (filters) => set({ filters }),

	updateFilter: (key, value) =>
		set((state) => ({
			filters: {
				...state.filters,
				[key]: value
			}
		})),

	clearFilters: () => set({ filters: {} }),

	hasActiveFilters: () => {
		const { filters } = get();
		return Object.keys(filters).some((key) => {
			const value = filters[key];
			return (
				value !== undefined &&
				value !== null &&
				((Array.isArray(value) && value.length > 0) ||
					(typeof value === 'string' && value.trim() !== '') ||
					typeof value === 'number')
			);
		});
	}
}));
